module.exports = __webpack_public_path__ + "src/img/search.946c7ce2.svg";